export const NEXT_STEP = 'INTRODUCTION_LAYER::NEXT_STEP';

export function nextStep() {
    return {
        type: NEXT_STEP,
    };
}

export const RESET_STEPS = 'INTRODUCTION_LAYER::RESET_STEPS';

export function resetSteps() {
    return {
        type: RESET_STEPS,
    };
}

export const TOGGLE_VISIBILITY = 'INTRODUCTION_LAYER::TOGGLE_VISIBILITY';

export function toggleVisibility() {
    return {
        type: TOGGLE_VISIBILITY,
    };
}
